import AurigaLoader from '@components/Common/AurigaLoader';

/**
 * AuthLoading Component
 *
 * Displays a centered loading spinner with "Authenticating..." text.
 * This component is shown during:
 * - Initial authentication checks when the application loads
 * - Authentication redirects to the identity provider
 * - Post-authentication processing
 */
const AuthLoading = () => {
  return <AurigaLoader loaderText='Authenticating...' />;
};

export default AuthLoading;
